import useBrand from '../../hooks/useBrand';
import parse from 'html-react-parser';
import fusionLogo from '../../assets/fusion-logo-primary.svg';

export default function Header() {
  const brand = useBrand();
  const header = brand?.header;
  const useFallback = brand?.useFallback;

  if (header) {
    return parse(header);
  }

  // fallback default header
  if (useFallback) {
    return (
      <header id="header-wrap" className="clearfix fallback border-bottom">
        <div className="container-fluid but-fixed">
          <div className="row">
            <div id="header" className="col-sm-12">
              <a className="logo my-2 my-md-3 float-start d-flex align-items-center border-0" href="/">
                <img src={fusionLogo} alt="Certus" width="180" height="50" loading="lazy" style={{ maxWidth: '180px' }} />
              </a>
              <div id="support">
                <a className="login" href="https://fusion.certus.com/" target="_blank" rel="noreferrer noopener">
                  Login
                </a>
              </div>
            </div>
          </div>
        </div>
      </header>
    );
  }

  // skeleton header
  return (
    <header id="header-wrap" className="clearfix border-bottom">
      <div className="container-fluid but-fixed">
        <div className="row">
          <div id="header" className="col-sm-12">
            <div className="my-2 my-md-3 float-start d-flex" style={{ width: '100%', maxWidth: '300px' }}>
              <span className="animated-placeholder rounded-2" style={{ width: '100%', height: '50px' }}></span>
            </div>

            {/* <div className="brand float-end d-none d-sm-block mt-2 mt-md-3">
              <div className="desktop-brand mt-2 mt-md-2" style={{ height: '33px' }}>
                <span className="powered-by d-inline-block align-middle mb-0 me-2">Powered By:</span>
                <span className="d-inline-block align-middle">
                  <span className="animated-placeholder rounded-2 d-block" style={{ width: '120px', height: '33px' }}></span>
                </span>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </header>
  );
}
